import { render, staticRenderFns } from "./WhiteLists.vue?vue&type=template&id=a2703568&"
import script from "./WhiteLists.vue?vue&type=script&lang=ts&"
export * from "./WhiteLists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports